import { REG_LIST_PATH, REG_PRODUCT_PATH } from 'base/config/constant';
import { getQueryFromPath } from 'base/utils/getQueryFromPath';
import { callApp } from 'base/utils/bridge';
import { RouteEnum } from 'pro/config/routers';
import { getStoreState } from 'base/store';
import router from 'next/router';
import { getSearch, getParamInSearch } from 'ava-util/dist/request';
import { getNativePage, nativeLogin } from 'base/utils/app';

export const nativePages: Array<{
    url?: string;
    reg?: RegExp;
    callback: (pathname: string, url: string) => void
}> = [
    // 列表页
    {
        reg: REG_LIST_PATH,
        callback: (pathname) => {
            const { listSn } = getQueryFromPath(pathname);
            callApp('nativeProductList', { 'listId': listSn })
        }
    },
    // 商品详情页
    {
        reg: REG_PRODUCT_PATH,
        callback: (pathname) => {
            const { productId, variantId } = getQueryFromPath(pathname);
            callApp('nativeProductDetails', {
                spuId: productId,
                skuId: variantId
            });
        }
    },
    // 登录注册
    {
        url: RouteEnum.LOGIN,
        callback: (pathname, url) => {
            nativeLogin(()=>{
                const redirect = getParamInSearch('redirect', getSearch(url));
                if (redirect) {
                    const redirectPathname = redirect.replace(/[?#].*$/, '');
                    const nativePage = getNativePage(redirectPathname);
                    if(nativePage) {
                        nativePage.callback(redirectPathname, redirect);
                    } else {
                        router.push(redirect);
                    }
                } else {
                    router.reload();
                }
            });
        }
    },
    // 优惠券页
    {
        url: RouteEnum.COUPONS,
        callback: () => {
            const { userId } = getStoreState('userStore');
            callApp('nativeCouponPage', { userId });
        }
    },
    // 积分页
    {
        url: RouteEnum.POINTS,
        callback: () => {
            const { userId } = getStoreState('userStore');
            callApp('nativePointsPage', { userId });
        }
    },
    // 购物车页
    {
        url: RouteEnum.CART,
        callback: () => {
            const { userId } = getStoreState('userStore');
            callApp('nativeCartPage', { userId });
        }
    },
];